<template>
  <div>
    <v-row class="py-0">
      <v-col cols="6">
        <h3 class="title dw_green--text font-weight-light">
          <v-icon color="dw_green" class="mr-2 mb-1" v-text="mdiPaletteSwatchOutline" />
          Add a Tool
        </h3>
        <v-form ref="addToolForm" v-model="formValid" @submit.prevent>
          <v-card flat color="bg_dark">
            <v-card-text class="px-4 py-0">
              <v-text-field
                v-model="newTool"
                :counter="256"
                placeholder="Add a new tool here *"
                color="dw_green"
                :rules="[vRules.required, vRules.min, vRules.max, vRules.textRegex]"
              ></v-text-field>
              <v-text-field
                v-model="newToolUrl"
                placeholder="Source URL *"
                color="dw_green"
                :rules="[vRules.required, vRules.min, vRules.urlRegex]"
              ></v-text-field>
              <v-textarea
                v-model="newToolDesc"
                :counter="512"
                placeholder="Short Description"
                color="dw_green"
                :rules="[vRules.min, vRules.descMax]"
              ></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                type="button"
                @click="resetForm"
                color="dw_green"
                x-small
                text>Clear</v-btn>
              <v-btn
                type="submit"
                :disabled="!formValid"
                @click="addTool"
                color="dw_green"
                small
                outlined>
                Add
                <v-icon small color="dw_green" class="ml-1" v-text="mdiPaletteSwatch" />
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>
      <v-col cols="6">
        <tool-list />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mdiPaletteSwatch, mdiPaletteSwatchOutline, mdiMagnify } from '@mdi/js';
import { mapActions } from 'vuex';
import toolList from '@/components/forms/simpleLists/toolList.vue';
import utils from '@/utils/index';

export default {
  name: 'addTool',
  components: {
    toolList
  },
  data() {
    return {
      mdiPaletteSwatch,
      mdiPaletteSwatchOutline,
      mdiMagnify,
      formValid: false,
      newTool: '',
      newToolUrl: '',
      newToolDesc: '',
      vRules: utils.validationRules
    };
  },
  methods: {
    ...mapActions([
      'fetchToolOptions',
      'createTool'
    ]),
    async addTool() {
      try {
        await this.createTool({
          name: this.newTool,
          url: this.newToolUrl,
          description: this.newToolDesc
        });
        this.fetchToolOptions();
        this.resetForm();
      } catch (err) {
        console.error(err);
      }
    },
    resetForm() {
      this.newTool = '';
      this.newToolUrl = '';
      this.newToolDesc = '';
      this.$refs.addToolForm.resetValidation();
    }
  }
};
</script>
